import React from 'react';

import { Button } from '@sravni/react-design-system';
import { useBoolean } from '@sravni/react-utils';

import { useRubrics } from '../../hooks/news';

import { DialogRubricMenu } from './components';
import { Item } from './components/Item';
import styles from './rubrics-menu.module.scss';

interface RubricsMenuProps {
  subscriptionPopupState: [number, (value: number) => void];
}

export const RubricsMenu = ({ subscriptionPopupState }: RubricsMenuProps) => {
  const rubrics = useRubrics();
  const [viewDialogRubricMenu, setViewDialogRubricMenu] = useBoolean(false);

  const handleViewDialogRubricMenu = () => {
    setViewDialogRubricMenu.off();
  };

  if (!rubrics?.length) return null;

  return (
    <div className={styles.wrapper}>
      <div className={styles.wrapperRubrics}>
        {rubrics?.slice(0, 6).map((item) => (
          <Item item={item} />
        ))}
      </div>
      <Button
        onClick={setViewDialogRubricMenu.on}
        color="blue"
        variant="text"
        block
        size={36}
        className={styles.allRubricButton}
      >
        Все рубрики
      </Button>
      <DialogRubricMenu
        subscriptionPopupState={subscriptionPopupState}
        view={viewDialogRubricMenu}
        closeView={handleViewDialogRubricMenu}
      />
    </div>
  );
};
